/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_SlaInputs */

const en_case_detail_sla = /** @type {(inputs: Case_Detail_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA`)
};

const pt_br2_case_detail_sla = /** @type {(inputs: Case_Detail_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA`)
};

/**
* | output |
* | --- |
* | "SLA" |
*
* @param {Case_Detail_SlaInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_sla = /** @type {((inputs?: Case_Detail_SlaInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_SlaInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_sla(inputs)
	return pt_br2_case_detail_sla(inputs)
});